import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';

const Modal = ({ show, handleClose, logInHandler, pathName, message, userSubscribe }) => {
  const navigate = useNavigate(); // Get the navigate function
const {t} = useTranslation();
  const handleLoginRedirect = () => {
    if(userSubscribe){
      navigate("/licenses"); // Navigate to the login page
    }else{
      navigate("/login"); // Navigate to the login page
    }
    handleClose();
  };

  const showHideClassName = show
    ? "custom-modal display-block"
    : "custom-modal display-none";

  return (
    <div className={showHideClassName} tabIndex="-1" role="dialog">
      <div className="custom-modal-dialog" role="document">
        <div className="custom-modal-content">
          <div className="custom-modal-header">
            <h5 className="custom-modal-title">{userSubscribe ? t('modal_plan_subscribe') : t('modal_Required')}</h5>
            <button
              type="button"
              className="close-btn"
              onClick={handleClose}
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="custom-modal-body">
            {pathName ? 
              <p>{ userSubscribe ? t('modal_Download_subscribe') : t('modal_Download')}</p>
              :    
              <p>{t('modal_please')}</p>
            }
          </div>
          <div className="custom-modal-footer">
            <button
              type="button"
              className="btn cancel-btn"
              onClick={handleClose}
            >
              {t('modal_Cancel')}
            </button>
            <button
              type="button"
              className="btn logout-btn"
              onClick={handleLoginRedirect} 
            >
             {userSubscribe ? t('modal_go_subscribe') : t('modal_go')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;



